import Grid from '@mui/material/Grid';
import {Controller} from "react-hook-form";
import React, {useRef} from 'react';
import { useTranslation } from 'react-i18next';
import UploadIcon from '@mui/icons-material/Upload';
import Button from '@mui/material/Button';
import {useUploadFileMutation} from "../../app/apis/upload.api";
import {DEFAULT_CONFIG_NAME, useConfig} from "../../app/config.ctx";

const BookletCoverImg = ({name}) => {
  const {t} = useTranslation();
  const uploadInputRef = useRef(null);
  const [uploadFile] = useUploadFileMutation();
  const { getConfigValue } = useConfig();

  const onChangeUpload = (e, onChange) => {
    let selectedFile = e.target.files[0];
    const formData = new FormData();
    formData.append('file', selectedFile);

    uploadFile(formData)
        .then((resp) => {
          onChange(resp.data.temporaryLocation)
        });
  }

  return <Controller
      name={name}
      render={({field}) => {
        return (
            <Grid container spacing={2}>
              <Grid item xs={4}>Booklets cover</Grid>
              <Grid item xs={8}>
                <Button variant="contained" onClick={() => uploadInputRef.current.click()}><UploadIcon
                    size="small"/>upload</Button>
                <input
                  type='file'
                  onChange={(e) => onChangeUpload(e, field.onChange)}
                  style={{display: 'none'}}
                  accept='.png, .jpeg, .jpg'
                  ref={uploadInputRef}
              /></Grid>
              <Grid item xs={12}>
                {field.value && <img src={`${getConfigValue(DEFAULT_CONFIG_NAME.BASE_URL)}${field.value}`} />}
              </Grid>
            </Grid>
        )
      }}
  />

}

export default BookletCoverImg;
